import component from "./Textarea";
export default component;
